module.exports = __webpack_public_path__ + "media/assets/faria_products/HIGH-6212001c289103b38a0839b1f41e0905ecd84d74fd10bdea7c4e6c685f49e369.png";